import { render, staticRenderFns } from "./AllocationIncompleteWorkersList.vue?vue&type=template&id=24092a54&"
import script from "./AllocationIncompleteWorkersList.vue?vue&type=script&lang=js&"
export * from "./AllocationIncompleteWorkersList.vue?vue&type=script&lang=js&"
import style0 from "./AllocationIncompleteWorkersList.vue?vue&type=style&index=0&id=24092a54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports